import { render, staticRenderFns } from "./FinishCreateCalendarTutorialModal.vue?vue&type=template&id=05180a16&scoped=true&"
import script from "./FinishCreateCalendarTutorialModal.vue?vue&type=script&lang=js&"
export * from "./FinishCreateCalendarTutorialModal.vue?vue&type=script&lang=js&"
import style0 from "./FinishCreateCalendarTutorialModal.vue?vue&type=style&index=0&id=05180a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05180a16",
  null
  
)

export default component.exports